var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import './LabelStyles.scss';
/**
 * Label Component
 * @version 1.0.0
 * @since 2026-01-19
 */
export const Label = forwardRef((_a, ref) => {
    var { className = '', children } = _a, props = __rest(_a, ["className", "children"]);
    const baseClass = 'qmb-ui-label';
    const combinedClass = [baseClass, className].filter(Boolean).join(' ');
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("label", Object.assign({ ref: ref, className: combinedClass }, props), children));
});
Label.displayName = 'Label';
